import { matchPath } from 'react-router';

import { RouteEnum } from 'app/shared/enums';

export const getPartnerLinkParams = () => {
  const { pathname } = window.location;
  const match = matchPath<{ partnerId?: string; brand?: string }>(pathname, {
    path: RouteEnum.PARTNER_LINK,
  });

  if (match?.params) {
    const { brand, partnerId } = match.params;

    if (brand && partnerId) {
      return { brand, partnerId };
    }
  }
};
